document.addEventListener('DOMContentLoaded', function () {
	const body = document.body;
	const toggleOpen = document.querySelector('.mobile-toggle-open');
	const toggleClose = document.querySelector('.mobile-toggle-close');
	const menuWrap = document.querySelector('.primary-menu-wrap');
	const primaryMenu = document.querySelector('.primary-menu');
	const dropdownLinks = document.querySelectorAll(
		'.primary-menu > .mega-menu-item-has-children > a'
	);
	const backButtons = document.querySelectorAll('.back-to-main');

	// Open menu
	toggleOpen?.addEventListener('click', function (e) {
		e.stopPropagation();
		menuWrap?.classList.toggle('mobile-toggle-show');
		if (menuWrap?.classList.contains('mobile-toggle-show')) {
			body.classList.add('is-mobile-menu-open');
			body.classList.add('disable-transform');
		} else {
			body.classList.remove('is-mobile-menu-open');
			setTimeout(() => {
				body.classList.remove('disable-transform');
			}, 300);
		}
	});

	// Prevent closing when clicking inside menu
	menuWrap?.addEventListener('click', function (e) {
		e.stopPropagation();
	});

	// Close when clicking outside of menu and submenu
	document.addEventListener('click', function (e) {
		const target = e.target;

		const isInsideMenu = menuWrap?.contains(target);
		const isToggleButton = toggleOpen?.contains(target);
		const isInsideChildMenu = document
			.querySelector('.mobile-child-toggle-show')
			?.contains(target);

		if (!isInsideMenu && !isToggleButton && !isInsideChildMenu) {
			menuWrap?.classList.remove('mobile-toggle-show');
			body.classList.remove('is-mobile-menu-open');
			setTimeout(() => {
				body.classList.remove('disable-transform');
			}, 300);
			document
				.querySelectorAll('.mega-menu-item-has-children')
				.forEach((item) =>
					item.classList.remove('mobile-child-toggle-show')
				);
			primaryMenu?.classList.remove('main-toggle-left');
		}
	});

	// Close button
	toggleClose?.addEventListener('click', function () {
		menuWrap?.classList.remove('mobile-toggle-show');
		body.classList.remove('is-mobile-menu-open');
		setTimeout(() => {
			body.classList.remove('disable-transform');
		}, 300);
		document
			.querySelectorAll('.mega-menu-item-has-children')
			.forEach((item) =>
				item.classList.remove('mobile-child-toggle-show')
			);
		primaryMenu?.classList.remove('main-toggle-left');
	});

	// Dropdown trigger - accessible with click and focus
	dropdownLinks.forEach((link) => {
		const parentItem = link.closest('.mega-menu-item-has-children');

		const activate = (e) => {
			e.preventDefault();
			document
				.querySelectorAll('.mega-menu-item-has-children')
				.forEach((item) =>
					item.classList.remove('mobile-child-toggle-show')
				);
			parentItem?.classList.add('mobile-child-toggle-show');
			primaryMenu?.classList.add('main-toggle-left');
		};

		link.addEventListener('click', activate);
		link.addEventListener('focus', activate); // Keyboard tab support
	});

	// Back to main menu
	backButtons.forEach((btn) => {
		btn.addEventListener('click', function () {
			const parentItem = btn.closest('.mega-menu-item-has-children');
			parentItem?.classList.remove('mobile-child-toggle-show');
			primaryMenu?.classList.remove('main-toggle-left');
		});
	});

	// Auto-close child menu when tabbing out
	document
		.querySelectorAll('.mega-menu-item-has-children')
		.forEach((item) => {
			item.addEventListener('focusout', () => {
				setTimeout(() => {
					if (
						!item.contains(document.activeElement) &&
						document.activeElement !== document.body
					) {
						item.classList.remove('mobile-child-toggle-show');
						primaryMenu?.classList.remove('main-toggle-left');
					}
				}, 0);
			});
		});
});

// Global state to inform header.js
window.isMegaHover = false;
const megaMenuItems = document.querySelectorAll(
	'li.wp-block-matat-pandora-mega-menu-item-mega'
);

// Hover behavior to trigger header state change
megaMenuItems.forEach((item) => {
	item.addEventListener('mouseenter', function () {
		window.isMegaHover = true;
		const event = new Event('headerStateUpdate');
		document.dispatchEvent(event);
	});

	item.addEventListener('mouseleave', function () {
		window.isMegaHover = false;
		const event = new Event('headerStateUpdate');
		document.dispatchEvent(event);
	});
});

// Mobile dropdown add / remove class Menu
// const menu = document.querySelector('.primary-menu');
// const menuLinks = document.querySelectorAll('.mega-menu-item-has-children > .menu-item-link');

// menuLinks.forEach(link => {
// 	link.addEventListener('click', function (e) {
// 		e.preventDefault();
// 		e.stopPropagation();

// 		const parentLi = this.closest('.mega-menu-item-has-children');
// 		const dropdown = parentLi.querySelector('.primary-menu__dropdown');

// 		// Assume the wrapper <div> you want to target is the closest parent with class `.menu-item`
// 		const wrapper = parentLi.closest('.menu-item');

// 		// Remove dropdown-active and active-drop from all
// 		document.querySelectorAll('.primary-menu__dropdown.dropdown-active').forEach(dd => {
// 			dd.classList.remove('dropdown-active');
// 		});
// 		document.querySelectorAll('.menu-item.active-drop').forEach(dd => {
// 			dd.classList.remove('active-drop');
// 		});

// 		// Toggle current dropdown and wrapper
// 		if (dropdown) dropdown.classList.toggle('dropdown-active');
// 		if (wrapper && dropdown.classList.contains('dropdown-active')) {
// 			wrapper.classList.add('active-drop');
// 		}
// 	});
// });

// // Close all on outside click
// document.addEventListener('click', function () {
// 	document.querySelectorAll('.primary-menu__dropdown.dropdown-active').forEach(dd => {
// 		dd.classList.remove('dropdown-active');
// 	});
// 	document.querySelectorAll('.menu-item.active-drop').forEach(dd => {
// 		dd.classList.remove('active-drop');
// 	});
// });
// document.addEventListener("DOMContentLoaded", function () {
//   const menus = document.querySelectorAll(".wp-block-matat-pandora-mega-menu-item-mega");
//   const childSelector = [
//     ".wc-block-product-categories.wc-block-product-categories ul li",
//     ".wp-block-heading",
//     "p",
//     "h1","h2","h3","h4","h5","h6",
//     "figure",
//     ".wp-block-list li"
//   ].join(",");

//   const step = 5; // ms between each item animation

//   menus.forEach(menu => {
//     const items = menu.querySelectorAll(childSelector);

//     menu.addEventListener("mouseenter", () => {
//       items.forEach((el, i) => {
//         el.style.setProperty("--delay", `${i * step}ms`);
//       });
//       menu.classList.add("is-open");
//     });

//     menu.addEventListener("mouseleave", () => {
//       items.forEach((el, i) => {
//         el.style.setProperty("--delay", `0ms`);
//       });
//       menu.classList.remove("is-open");
//     });
//   });
// });
// sub-menu animation

